module.exports = __webpack_public_path__ + "img/house_pv_on.10e498d0.png";